import { Badge, BadgeProps } from '@commenda/kakashi';
import moment from 'moment';
import {
  FilingReviewStatus,
  FilingReviewStatusColorMap,
  FilingReviewStatusNameMap,
} from '../types';

interface FilingStatusBadgeProps {
  status: FilingReviewStatus;
}

export function FilingStatusBadge({ status }: FilingStatusBadgeProps) {
  return (
    <Badge
      size="sm"
      variant={FilingReviewStatusColorMap[status] as BadgeProps['variant']}
    >
      {FilingReviewStatusNameMap[status]}
    </Badge>
  );
}

export const FilingStatusBadgeWithDueDate = ({
  status,
  dueDate,
}: {
  status: FilingReviewStatus;
  dueDate: string;
}) => {
  return (
    <div className="flex gap-lg border border-border-primary text-text-quaternary rounded-md px-md py-sm text-sm">
      <span className="text-text-quaternary txt-small-medium">
        Due: {moment(dueDate).format('MMM D, YYYY')}
      </span>
      <FilingStatusBadge status={status} />
    </div>
  );
};
